export default {
  init() {

    // DOM Elements
    this.crossSellsEl = $('.cross-sells-carousel')
    this.checkoutButton = $('.checkout-button')

    if (this.crossSellsEl.length) {
      this.crossSellsCarousel()
    }

  },
  crossSellsCarousel() {
    
    // Set preferred slidesToShow
    var slidesToShowMobile = 2;
    var numSlides = $('.cross-sells__item').length;

    if( numSlides < slidesToShowMobile ) {
      slidesToShowMobile = numSlides;
    }

    this.crossSellsEl.slick({
      dots: true,
      arrows: false,
      infinite: false,
      speed: 500,
      adaptiveHeight: true,
      mobileFirst: true,
      slidesToScroll: slidesToShowMobile,
      slidesToShow: slidesToShowMobile,
      responsive: [
        {
          breakpoint: 768,
          settings: 'unslick',
        },
      ],
    })

  },
};
